import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController, AlertController } from '@ionic/angular';
import { FileService } from '../../services/file.service'
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { ViewAssetModalPage } from '../view-asset-modal/view-asset-modal.page';
import { BaseAsset } from 'src/app/models/assets/BaseAsset';
import { TextAsset } from 'src/app/models/assets/TextAsset';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { HotSpotAsset } from 'src/app/models/assets/HotSpotAsset';
import { Model3DAsset } from 'src/app/models/assets/Model3DAsset';
import { QuestionResponse } from 'src/app/models/assets/QuestionResponse';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { ApiAssetService } from 'src/app/api-services/asset.api.service';
import { ValidationService } from 'src/app/services/validation.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { QuestionSetAsset } from 'src/app/models/assets/QuestionSetAsset';
import { InvisibleAsset } from 'src/app/models/assets/InvisibleAsset';
import { FileSizeService } from 'src/app/services/file-size.service';
import { MessagesService } from 'src/app/services/messages.service';
@Component({
  selector: 'app-add-asset-within-scene-modal',
  templateUrl: './add-asset-within-scene-modal.page.html',
  styleUrls: ['./add-asset-within-scene-modal.page.scss'],
})
export class AddAssetWithinSceneModalPage implements OnInit {

  public baseAsset: BaseAsset;
  public baseAssetSrc: string = "";
  public assetType: string;
  public existingAssetsInScene: AssetInScene[] = [];
  public assetsOnAssetManagementPage = [];
  public assetsOnAssetManagementPageCopy = [];
  public existingScenes: Scene[] = [];
  public shouldAddNewAsset: boolean = false;
  public shouldAddToAssetPage: boolean = false;
  public loadFromAssetsPage;
  public uploadedFileType: string;
  public assetIDToCopy: number = -1;
  public fileUploaded: boolean = false;
  public displayAddButton: boolean = true;
  public numberOfAssetTypes: number;
  public noAssetsOfType: boolean;
  public assetSearchTerm: string;
  public searchNotFound: boolean = false;
  public questionsInQuestionSetAsset: QuestionAsset[] = [];
  public buttonNotSelected = true;
  public isModalOpen: boolean = false;
  public compressVideo: boolean = false;
  public assetSrc;
  public aspectRatioConstant: number = 0.5;
  public baseAssetDefaultName: string = "";

  constructor(
    private sanitizer: DomSanitizer,
    public alertController: AlertController,
    public modalController: ModalController,
    public fileService: FileService,
    public assetManagementService: AssetManagementService,
    public assetTypeService: AssetTypeService,
    public assetAPIService: ApiAssetService,
    public validationService: ValidationService,
    public unfocusService: UnfocusElementService,
    public deepCopyService: DeepCopyService,
    public fileSizeService: FileSizeService,
    public messagesService: MessagesService
  ) { }

  async ngOnInit() {
    this.buttonNotSelected = true;
    if (this.assetManagementService.assets == undefined || this.assetManagementService.assets.length == 0) {
      await this.assetManagementService.getAssetsOnManagementPage();
    }
    this.assetType = this.assetTypeService.getType(this.baseAsset.assetTypeId);
    this.assetsOnAssetManagementPage = this.deepCopyService.deepCopy(this.assetManagementService.assets.filter((x: any) => x.assetTypeId == this.baseAsset.assetTypeId && x.isBackground == "false"));
    this.assetsOnAssetManagementPageCopy = this.deepCopyService.deepCopy(this.assetManagementService.assets.filter((x: any) => x.assetTypeId == this.baseAsset.assetTypeId && x.isBackground == "false"));
    if (this.assetType == 'Image' || this.assetType == 'Video' || this.assetType == 'Audio') {
      this.displayAddButton = false;
      this.baseAssetDefaultName = this.deepCopyService.deepCopy(this.baseAsset.name);
      this.numberOfAssetTypes = this.assetManagementService.assets.filter(x => x.assetTypeId == this.baseAsset.assetTypeId).length;
    }
    else if (this.assetType == 'QuestionSet') {
      this.addQuestion();
    }
    else {
      this.displayAddButton = true;
      this.numberOfAssetTypes = 0;
      this.noAssetsOfType = false
    }
  }

  resetMediaModal(event) {
    this.unfocusService.unfocus(event);
    this.displayAddButton = false;
    this.buttonNotSelected = true;
    this.shouldAddNewAsset = false;
    this.loadFromAssetsPage = false;
    this.fileUploaded = false;
    this.baseAsset.name = this.baseAssetDefaultName;
  }

  checkboxSelected(buttonClicked, event) {
    this.unfocusService.unfocus(event);
    this.displayAddButton = true;
    this.buttonNotSelected = false;
    if (buttonClicked == "assetManagement") {
      this.loadFromAssetsPage = true;
      this.shouldAddNewAsset = false;
      if (this.numberOfAssetTypes == 0) {
        this.noAssetsOfType = true;
      }
      else {
        this.noAssetsOfType = false;
      }
    }
    else {
      this.shouldAddNewAsset = true;
      this.loadFromAssetsPage = false;
      this.noAssetsOfType = false;
    }
  }

  coverPageChanged(event) {
    var baseAsset = this.baseAsset as QuestionSetAsset;
    baseAsset.questionIndex = event.target.checked == true ? -1 : 0;
    this.baseAsset = baseAsset;
  }

  async launchAsset(asset) {
    // Because of a circular dependency - this section is in the modalService too

    if (this.isModalOpen === true) return;
    this.isModalOpen = true;

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.assetTypeService.getType(asset.assetTypeId) + '-modal',
      componentProps: {
        "assetModalData": asset
      }
    });

    modal.onDidDismiss().then(() => {
      this.isModalOpen = false;
    });

    return await modal.present();
  }

  // modal.onDidDismiss(). found in author.service
  closeModalAndPassAsset() {
    if (this.assetType == 'QuestionSet') {
      var dataQuestionSet = { "assetType": this.assetType, "baseAsset": this.baseAsset, "questions": this.questionsInQuestionSetAsset };
      this.modalController.dismiss(dataQuestionSet);
    } else if (this.validationService.isMediaAsset(this.assetType)) {
      var dataMedia = { "assetType": this.assetType, "baseAsset": this.baseAsset, "baseAssetSrc": this.baseAssetSrc, "aspectRatioConstant": this.aspectRatioConstant };
      this.modalController.dismiss(dataMedia);
    } else {
      var data = { "assetType": this.assetType, "baseAsset": this.baseAsset };
      this.modalController.dismiss(data);
    }
  }

  cancelModal() {
    this.modalController.dismiss();
  }

  setModalHeight(index) {

    var modal = document.getElementById('add-question-object-modal').querySelector('.modal-wrapper');
    if (index == 1) {
      modal.classList.remove('two-response');
    }
    else if (index == 2) {
      modal.classList.remove('three-response');
      modal.classList.add('two-response');
    }
    else if (index == 3) {
      modal.classList.remove('four-response');
      modal.classList.remove('two-response');
      modal.classList.add('three-response');
    }
    else if (index == 4) {
      modal.classList.remove('three-response');
      modal.classList.add('four-response');
    }
  }

  addResponse(baseAsset: QuestionAsset, i: number = 0) {
    var response: QuestionResponse = new QuestionResponse();
    response.isCorrect = i == 1 ? true : false;
    response.text = 'Default Response ' + (i >= 1 ? i : '');
    response.textSize = 30;
    response.hasImage = false;
    response.imageSceneAssetRelationId = 0;
    response.hasVideo = false;
    response.videoSceneAssetRelationId = 0;
    response.hasAudio = false;
    response.audioSceneAssetRelationId = 0;
    response.hasLinkedScene = false;
    response.linkedSceneID = 0;
    response.fontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";

    baseAsset.responses.push(response);
  }

  removeResponse(index) {
    var qAsset: QuestionAsset = this.baseAsset as QuestionAsset;
    if (qAsset.responses[index].isCorrect) {
      this.responseIsCorrectSelect(0);
    }

    qAsset.responses.splice(index, 1);
    this.baseAsset = qAsset;
  }

  responseIsCorrectSelect(i) {
    var qAsset: QuestionAsset = this.baseAsset as QuestionAsset;
    qAsset.responses.forEach(element => {
      element.isCorrect = false;
    });
    qAsset.responses[i].isCorrect = true;
    this.baseAsset = qAsset;
  }

  addQuestion() {
    var question: QuestionAsset = new QuestionAsset();
    question.assetTypeId = this.assetTypeService.getId('Question') as number;
    question.name = "Default Question"
    question.text = "Default Question"
    question.planeColour = '#ffffff';
    question.textColour = '#000000';
    question.fontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    question.backgroundOpacity = 1;
    question.textSize = 30;
    question.correctMessage = "Well Done!";
    question.incorrectMessage = "You got this wrong!";
    question.score = 1;
    question.hasFeedback = true;
    question.responses = [];
    this.addResponse(question, 1);
    this.addResponse(question, 2);
    question.responses[0].isCorrect = true;
    this.questionsInQuestionSetAsset.push(question);
  }

  removeQuestion(index) {
    this.questionsInQuestionSetAsset.splice(index, 1);
  }

  addAsset(event, files) {
    this.unfocusService.unfocus(event);
    var asset;

    switch (this.assetType) {
      case 'Text': {
        asset = this.baseAsset as TextAsset;
        break;
      }
      case 'Image':
      case 'Video':
      case 'Audio': {
        asset = this.baseAsset as MediaAsset;
        break;
      }
      case 'HotSpot': {
        asset = this.baseAsset as HotSpotAsset;
        break;
      }
      case 'Question': {
        asset = this.baseAsset as QuestionAsset;
        break;
      }
      case 'Model3D': {
        asset = this.baseAsset as Model3DAsset;
        break;
      }
      case 'QuestionSet': {
        asset = this.baseAsset as QuestionSetAsset;
        break;
      }
      case 'Invisible': {
        asset = this.baseAsset as InvisibleAsset;
        break;
      }
    }

    asset.name = this.validationService.removeHtmlTags(asset.name);

    // modal.onDidDismiss().then(...) found in modal.service, method: openAddAssetWithinSceneModal

    if (this.loadFromAssetsPage) {
      //console.log(this.assetIDToCopy);
      if (this.assetIDToCopy == -1 || this.assetIDToCopy == undefined) {
        this.validationService.alertForNoMediaSelected(asset);
      }
      else {
        asset.assetManagementPageId = this.deepCopyService.deepCopy(this.assetIDToCopy);
        this.assetIDToCopy = -1;

        if (asset.assetManagementPageId <= 0) {
          this.validationService.alertForMissingAssetProperties(asset);
        } else {
          this.closeModalAndPassAsset();
        }
      }
    }
    else if (this.validationService.isMediaAsset(this.assetType)) {
      this.createMediaAsset(asset, files);
    } else if (this.assetType == 'QuestionSet') {
      if (!this.validationService.isAssetAddedThroughSceneValid(asset)) {
        this.validationService.alertForMissingAssetProperties(asset);
      } else if (!this.validationService.isAssetsInAssetAddedThroughSceneValid(this.questionsInQuestionSetAsset)) {
        this.validationService.alertForMissingAssetsInAssetProperties(this.questionsInQuestionSetAsset);
      } else {
        this.closeModalAndPassAsset();
      }
    } else {
      if (!this.validationService.isAssetAddedThroughSceneValid(asset)) {
        this.validationService.alertForMissingAssetProperties(asset);
      } else {
        this.closeModalAndPassAsset();
      }

    }

  }


  async createMediaAsset(asset, files) {
    if (!this.validationService.isMediaAssetValid(asset)) {
      this.validationService.alertForMissingAssetProperties(asset);
    }
    else if (!this.validationService.doesUploadedFileMatchAssetType(asset.assetTypeId)) {
      this.validationService.createAlert('Wrong Media Type Uploaded.');
    } else if (!this.validationService.isFileFormatCorrect(asset.assetTypeId)) {
      this.validationService.createAlert('Unsupported File Format.');
    } else {
      if (this.fileUploaded == true) {
        this.baseAssetSrc = await this.uploadFile(files);
        this.baseAsset.fileSize = await this.fileSizeService.getFileSize(this.baseAssetSrc);
      }
      if (this.shouldAddToAssetPage) {
        let oldSrc = asset.src;
        if (this.baseAssetSrc !== '') asset.src = this.baseAssetSrc;

        this.assetManagementService.createAsset(asset, false).then(result => {
          asset.src = oldSrc;
          this.baseAsset.baseAssetId = result.baseAssetId;
          this.assetManagementService.assets.push(result);
        });
      }
      this.closeModalAndPassAsset();
    }
  }

  setUpFileType(event) {
    if (event.target.files.length > 0) {
      this.fileUploaded = true;
    }
    this.baseAsset.mediaFileExtension = this.getFileExtension(event.target.files[0].name);
    this.validationService.setFileType(event);
  }

  getFileExtension(fileName: string): string {
    return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
  }

  async selectFile(event) {
    let mediaAsset: MediaAsset = this.baseAsset as MediaAsset;
    if (!this.validationService.doesUploadedFileMatchAssetType(mediaAsset.assetTypeId)) {
      this.validationService.createAlert('Wrong Media Type Uploaded.');
    } else if (!this.validationService.isFileFormatCorrect(mediaAsset.assetTypeId)) {
      this.validationService.createAlert('Unsupported File Format.');
    }

    //await this.messagesService.presentLoadingWindow("Loading File, please wait...");

    if (mediaAsset.name.trim().length == 0) mediaAsset.name = event.target.files[0].name;
    mediaAsset.src = URL.createObjectURL(event.target.files[0]);
    this.assetSrc = this.sanitizer.bypassSecurityTrustUrl(mediaAsset.src);

    //this.fileService.fileEvent($event, '5a0ffb5a-475d-4307-bf05-237f82a9302d', this.baseAsset, 'src');
  }

  uploadFile(files): Promise<string> {
    return this.fileService.fileEventUpload(files, '5a0ffb5a-475d-4307-bf05-237f82a9302d', this.compressVideo);
  }

  async launchAssetPreview() {
    // This sanitizer fix the error: unsafe: data:audio/wav;, data:image/svg;

    if (this.isModalOpen === true) return;
    this.isModalOpen = true;

    var oldSrc = this.baseAsset["src"];
    this.baseAsset["src"] = this.sanitizer.bypassSecurityTrustUrl(oldSrc);

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.assetType + '-modal',
      componentProps: {
        "assetModalData": this.baseAsset
      }
    });

    modal.onDidDismiss().then(data => {
      this.baseAsset["src"] = oldSrc;
      this.isModalOpen = false;
    });

    return await modal.present();
  }

  searchByAsset(event) {
    let name: string = event.target.value;
    this.assetsOnAssetManagementPage = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageCopy);
    var assets = this.assetsOnAssetManagementPage.filter(x => x.name.toLowerCase().includes(name.toLowerCase()));
    if (assets.length == 0) {
      this.searchNotFound = true;
      this.assetsOnAssetManagementPage = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageCopy);
    }
    else {
      this.searchNotFound = false;
      this.assetsOnAssetManagementPage = assets;
    }
  }

  onMediaLoad(event) {
    switch (this.assetType) {
      case 'Image': {
        let imageWidth: number = event.target.naturalWidth;
        let imageHeight: number = event.target.naturalHeight;
        this.aspectRatioConstant = imageWidth == 0 ? imageHeight : (imageHeight / imageWidth);
        this.messagesService.loadingWindow.dismiss();
        break;
      }
      case 'Video': {
        let videoWidth: number = event.target.videoWidth;
        let videoHeight: number = event.target.videoHeight;
        this.aspectRatioConstant = videoWidth == 0 ? videoHeight : (videoHeight / videoWidth);
        this.messagesService.loadingWindow.dismiss();
        break;
      }
    }
  }

  // confirmAssetDetailsAreEntered(asset): boolean {
  //   if (this.validationService.isEmptyOrNull(asset.name)) {
  //     this.alertMissingAssetProperty('Name');
  //     return false;
  //   }
  //   else if (this.assetType == 'Text') {
  //     if (this.validationService.isEmptyOrNull(asset.text)) {
  //       this.alertMissingAssetProperty('Text Value');
  //       return false;
  //     }
  //   }
  //   else if (this.assetType == 'Image' || this.assetType == 'Video' || this.assetType == 'Audio' || this.assetType == 'Model3D') {
  //     if (this.validationService.isEmptyOrNull(asset.src)) {
  //       this.alertMissingAssetProperty('File');
  //       return false;
  //     }
  //   }

  //   return true;
  // }

  // async alertMissingAssetProperty(missingProperty: string) {
  //   const alert = await this.alertController.create({
  //     header: 'Asset ' + missingProperty + ' Required',
  //     buttons: [{
  //       text: 'Ok',
  //     }
  //     ]
  //   });
  //   await alert.present();
  // }


}
